import BaseModal from "../../../BaseComponents/BaseModal/BaseModal";
import styles from "./ViewStatusModal.module.css";
import { CheckCircle, AlertCircle, Settings, Database, Bell, FileText } from "lucide-react";

const ViewStatusModal = ({ open, onClose, status }) => {
  if (!status) return null;

  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title="Flight Status Details"
      width="720px"
      footer={
        <button className={styles.closeBtn} onClick={onClose}>
          ✕ Close
        </button>
      }
    >
      {/* Status Header */}
      <div className={styles.statusHeader}>
        <div className={styles.statusIconLarge} style={{ background: `${status.color}15` }}>
          <span style={{ fontSize: '48px' }}>{status.icon}</span>
        </div>
        <div className={styles.statusInfo}>
          <div className={styles.statusBadge} style={{ background: `${status.color}15`, color: status.color }}>
            {status.code}
          </div>
          <h2 className={styles.statusName} style={{ color: status.color }}>{status.status}</h2>
          <p className={styles.statusDesc}>{status.description}</p>
        </div>
      </div>

      {/* Usage Section */}
      <div className={styles.section}>
        <h3 className={styles.sectionTitle}>
          <Database size={18} />
          System Usage
        </h3>
        <div className={styles.usageGrid}>
          {status.usedBy.map((system, index) => (
            <div key={index} className={styles.usageCard}>
              <div className={styles.usageIcon}>
                {system.includes("API") && "🔌"}
                {system.includes("Booking") && "📋"}
                {system.includes("Schedule") && "📅"}
                {system.includes("Customer") && "👤"}
                {system.includes("Communication") && "💬"}
                {system.includes("Document") && "📄"}
                {system.includes("Payment") && "💳"}
                {system.includes("PNR") && "🎫"}
                {system.includes("Search") && "🔍"}
                {system.includes("Operation") && "⚙️"}
                {system.includes("Notification") && "🔔"}
                {system.includes("Refund") && "💰"}
                {system.includes("Support") && "🎧"}
                {system.includes("Hold") && "⏸️"}
                {!system.includes("API") && !system.includes("Booking") && !system.includes("Schedule") && 
                 !system.includes("Customer") && !system.includes("Communication") && !system.includes("Document") && 
                 !system.includes("Payment") && !system.includes("PNR") && !system.includes("Search") && 
                 !system.includes("Operation") && !system.includes("Notification") && !system.includes("Refund") && 
                 !system.includes("Support") && !system.includes("Hold") && "📊"}
              </div>
              <span>{system}</span>
            </div>
          ))}
        </div>
      </div>

      {/* When Applied Section */}
      <div className={styles.section}>
        <h3 className={styles.sectionTitle}>
          <Settings size={18} />
          When Applied
        </h3>
        <div className={styles.infoBox}>
          <AlertCircle size={16} className={styles.infoIcon} />
          <p>{status.usage}</p>
        </div>
      </div>

      {/* Business Rules */}
      <div className={styles.section}>
        <h3 className={styles.sectionTitle}>
          <FileText size={18} />
          Business Rules
        </h3>
        <ul className={styles.rulesList}>
          <li>This status is read-only and managed by the system</li>
          <li>Cannot be manually created, edited, or deleted</li>
          <li>Used across multiple systems for flight tracking and operations</li>
          <li>Synced automatically with airline APIs and manual flight updates</li>
        </ul>
      </div>

      {/* Integration Points */}
      <div className={styles.integrationSection}>
        <div className={styles.integrationCard}>
          <div className={styles.integrationIcon} style={{ background: '#dbeafe' }}>
            <CheckCircle size={24} color="#2563eb" />
          </div>
          <div className={styles.integrationContent}>
            <h4>API Flights</h4>
            <p>Automatically applied based on airline responses</p>
          </div>
        </div>
        <div className={styles.integrationCard}>
          <div className={styles.integrationIcon} style={{ background: '#fef3c7' }}>
            <Settings size={24} color="#d97706" />
          </div>
          <div className={styles.integrationContent}>
            <h4>Manual Flights</h4>
            <p>Can be manually selected by operations team</p>
          </div>
        </div>
        <div className={styles.integrationCard}>
          <div className={styles.integrationIcon} style={{ background: '#e0e7ff' }}>
            <Bell size={24} color="#6366f1" />
          </div>
          <div className={styles.integrationContent}>
            <h4>Notifications</h4>
            <p>Triggers customer communication workflows</p>
          </div>
        </div>
      </div>
    </BaseModal>
  );
};

export default ViewStatusModal;